module.exports = __webpack_public_path__ + "static/media/goa.bca89bb1.png";